import { render, staticRenderFns } from "./ClientProperties.vue?vue&type=template&id=29771a17&"
import script from "./ClientProperties.vue?vue&type=script&lang=js&"
export * from "./ClientProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports